module.exports = __webpack_public_path__ + "img/update-table-icon.0982637b.svg";